<template>
    <Page :header="header[lang_].title" type="gray">
        <template v-slot:body>
            <div class="w-full flex flex-column gap-4 xl:gap-6 lg:gap-5 md:gap-4 pr-0 max-w-30rem">
                
                <!--PROFILE -->
                <Profile />

                <!--TG-->
                <Telegram />  

                <!--RECIPIENTS | SENDERS -->
                <MobMenu :headerTxt="content.recipients[lang_].title"
                    :footerTxt="content.recipients[lang_].changeBtn"
                    :items="recipientsList" />

                <!--KYC-->
                <MobMenu 
                    :headerTxt="content.kyc[lang_].title"
                    :footerTxt="content.kyc[lang_].footer"
                    :items="(userVerified) ? menuKycDone : menuKyc" />

                <!--SETTINGS-->
                <MobMenu 
                    :headerTxt="content.settings[lang_].title"
                    :items="[]">
                    <template v-slot:body>
                        <!--LANG-->
                        <div class="w-full flex flex-row px-3 py-2 border-100 border-bottom-1 cursor-pointer" @click="popupLang=true" style="min-height:50px">
                            <div class="flex mr-3 align-items-center">
                                <Avatar class="text-600" size="small" icon="pi pi-language" shape="circle"/>
                            </div>
                            <div class="flex flex-1 justify-content-left align-items-center">
                                <span class="text-600">{{ content.lang[lang_].title }}</span>
                            </div>
                            <div class="flex justify-content-right align-items-center">
                                <span class="text-sm text-blue-500 uppercase">{{ local }}</span>
                                <i class="text-blue-500 ml-2" :class="'pi pi-angle-right'" />
                            </div>
                        </div>

                        <!--THEME-->
                        <div class="w-full flex flex-row px-3 py-2 border-100" style="min-height:50px">
                            <div class="flex mr-3 align-items-center">
                                <Avatar v-if="isDarkTheme" class="text-600" size="small" icon="pi pi-moon" shape="circle"/>
                                <Avatar v-else class="text-600" size="small" icon="pi pi-sun" shape="circle"/>
                            </div>
                            <div class="flex flex-1 justify-content-left align-items-center">
                                <span class="text-600">{{ (isDarkTheme) ? content.theme[lang_].dark : content.theme[lang_].light }}</span>
                            </div>
                            <div class="flex justify-content-right align-items-center">
                                <ToggleSwitch v-model="themeMode" @click="changeColorMode" class="ml-2"/>
                            </div>
                        </div>
                    </template>
                </MobMenu>  

                <!--LOGOUT-->
                <MobMenu v-if="!isAuth && !isTgApp" :items="menuOut" />

            </div>
        </template> 
    </Page>

    <!--LANG POPUP-->
    <Dialog class="w-full surface-100 border-none" modal 
        v-model:visible="popupLang" 
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: 'auto' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'border-noround-bottom' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ content.lang[lang_].title }}</span>
        </template>
     
        <MobMenu :items="[]">
            <template v-slot:body>
                <div class="w-full flex flex-row px-3 py-2 border-100 border-bottom-1 cursor-pointer" style="min-height:50px" @click="change_lang('en')">
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">{{ locals[0].label }}</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        <i class="text-blue-500 ml-2" :class="(local=='en') ? 'pi pi-check' : ''" />
                    </div>
                </div>
                <div class="w-full flex flex-row px-3 py-2 border-100 cursor-pointer" style="min-height:50px" @click="change_lang('ru')">
                    <div class="flex flex-1 justify-content-left align-items-center">
                        <span class="text-600">{{ locals[1].label  }}</span>
                    </div>
                    <div class="flex justify-content-right align-items-center">
                        <i class="text-blue-500 ml-2" :class="(local=='ru') ? 'pi pi-check' : ''" />
                    </div>
                </div>
            </template>
        </MobMenu>  
        <template #footer>
            <span class="text-lg font-medium mb-5"></span>
        </template>
    </Dialog>
</template>

<script>
import Connect from         '@/assets/js/Connect.js'
import Helper from          '@/assets/js/Helper.js'
import Profile from         '@/components/personal/profile/Index.vue' 
import Telegram from        '@/components/personal/profile/Telegram.vue' 
import Page from            '@/components/sides/Page.vue' 
import MobMenu from         '@/components/sides/menu/MobMenu.vue' 
import { mapActions } from  'vuex'

export default {
    data(){
        return{
            header: {
                en: {title: "Profile"} ,
                ru: {title: "Профиль"} ,
            }, 
            locals: [
                { 
                    code: 'en',
                    label: 'English'
                },
                { 
                    code: 'ru',
                    label: 'Русский'
                }
            ],
            content: {
                recipients: {
                    en: {
                        title: 'Recipients',
                        changeBtn: 'View'
                    },
                    ru: {
                        title: 'Получатели',
                        changeBtn: 'Просмотреть'
                    }
                },
                settings: {
                    en: {
                        title: 'Settings',
                        changeBtn: 'Change'
                    },
                    ru: {
                        title: 'Настройки',
                        changeBtn: 'Изменить'
                    }
                },
                kyc: {
                    en: {title: 'Verification'},
                    ru: {title: 'Верификация'}
                },
                lang: {
                    en: {title: 'Language'},
                    ru: {title: 'Язык'}
                },
                theme: {
                    en: {
                        title: 'Theme',
                        light: 'Light',
                        dark: 'Dark'
                    },
                    ru: {
                        title: 'Тема',
                        light: 'Светлая',
                        dark: 'Темная'
                    }
                },
            },
            popupLang: false,
            themeMode: false,
            local: (this.$store.getters.StateLang) ? this.$store.getters.StateLang : (this.$i18n.locale) ? this.$i18n.locale : 'en',
            menuList: [
                { 
                    label: {
                        en: 'Profile',
                        ru: 'Профиль'
                    },
                    labelIcon: 'pi pi-user',
                    btnText: '',
                    btnIcon: 'pi pi-arrow-right',
                    href: '/personal/profile/' 
                },
            ],
            recipientsList: [
                {
                    label: {
                        en: 'Senders',
                        ru: 'Отправители'
                    },
                    labelIcon: 'pi pi-user',
                    btnText: '',
                    btnIcon: 'pi pi-angle-right',
                    href: '/personal/senders/' 
                },
                { 
                    label: {
                        en: 'Recipients',
                        ru: 'Получатели'
                    },
                    labelIcon: 'pi pi-address-book',
                    btnText: '',
                    btnIcon: 'pi pi-angle-right',
                    href: '/personal/recipients/' 
                },
            ],
            menuKyc: [
                { 
                    label: {
                        en: 'Not passed',
                        ru: 'Не пройдена'
                    },
                    labelIcon: 'pi pi-verified',
                    btnText: '',
                    btnIcon: 'pi pi-angle-right',
                    href: '/verify/' 
                },
            ],
            menuKycDone: [
                { 
                    label: {
                        en: 'Passed',
                        ru: 'Пройдена'
                    },
                    labelIcon: 'pi pi-verified',
                    btnText: '',
                    btnIcon: 'pi pi-check',
                    href: null 
                },
            ],
            menuOut: [
                { 
                    label: {
                        en: 'Logout',
                        ru: 'Выход'
                    },
                    labelIcon: 'pi pi-sign-out',
                    btnText: '',
                    btnIcon: 'pi pi-angle-right',
                    href: '/logout/'
                },
            ]
        }
    },
    components: {
        Page,
        Profile,
        Telegram,
        MobMenu,
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
        screenSize() { return this.$store.getters.StateScreenSize },
        userPhoto: function () { return this.$store.getters.StateUserPhoto },
        userTelegram: function () { return this.$store.getters.StateTelegramUsername },
        userVerified: function () { return this.$store.getters.StateVerified },
    },
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        async change_lang(lang) {
            this.$i18n.locale = lang
            this.local = lang
            try { await this.$store.dispatch('SetLang', lang).then(() => {}) } 
            catch { console.log('error store lang') }
            this.popupLang = false
        },
        changeColorMode(){
            const mode = this.isDarkTheme
            this.$store.dispatch('SetDarkTheme', !mode)
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted(){
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        if(this.isDarkTheme) this.themeMode = true
        else this.themeMode = false

        try {
            this.SetHeaderTitle(this.header[this.lang_].title)
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                class: 'text-xs opacity-0',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    }
}
</script>